export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8560.d6a67a31.jpg";